import{checkCustom}from"./check.js";

















export const getErrorClass=(ParentError,custom)=>{
const ParentClass=getParentClass(ParentError,custom);
return class extends ParentClass{}
};

const getParentClass=(ParentError,custom)=>{
if(custom===undefined){
return ParentError
}

checkCustom(custom,ParentError);
return custom
};